import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var EditOutlineSVG = function EditOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.7 6.58L25.42 2.3a1 1 0 00-.71-.3 1 1 0 00-.72.3l-21 21a.53.53 0 00-.06.1.66.66 0 00-.12.17 1.07 1.07 0 00-.07.19v.11l-.71 5A1 1 0 003 30h.14l5-.71h.11l.19-.07a.66.66 0 00.17-.12.33.33 0 00.1-.06l16.7-16.7L29.7 8a1 1 0 000-1.42zM7.53 27.32l-3.33.48.48-3.33L20.43 8.72l2.85 2.85zm17.18-17.17l-2.86-2.86 2.86-2.85 2.85 2.85z"
  }));
};
EditOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EditOutlineSVG);